
import {parseISO, format} from "date-fns";
import { isUndefined } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImages, faFileAlt } from "@fortawesome/free-solid-svg-icons";

function valToColor(paramVal, cellStyle){
    var styl = cellStyle.byValue.find(v => v.value === paramVal);
    if (isUndefined(styl)){
        return {color: cellStyle.byDefault.color, backgroundColor: cellStyle.byDefault.backgroundColor};
    }
    else {
        return {color: styl.color, backgroundColor: styl.backgroundColor};
    }
}


export default class GridLayout {

    static toAgGridLayout(src){
        var defaults = src.defaults;

        var columns = src.columns.map(col =>{
            var newColumn = {
                headerName: (col.label) ? col.label : col.title,
                field: col.field,
                hide: (col.hide) ? col.hide : defaults.hide,
                resizable: (col.resizable) ? col.resizable: defaults.resizable,
                sortable: (col.sortable) ? col.sortable: defaults.sortable,
                filter: (col.filter) ? col.filter: defaults.filter,
                width: (col.width) ? col.width: defaults.width,
                wrapText: col.wrap,
                autoHeight: col.wrap
            }

            if (col.cellRenderType){
                if (col.cellRenderType ==="IsoUtcDateTimeToLocalRenderer"){
                    newColumn.cellRenderer = function(params) {return (params?.value) ? format(parseISO(params.value), "yy-MM-dd hh:mm") : ""};
                }
                else if (col.cellRenderType === "TrueFalseImageRenderer")
                {
                    newColumn.cellRenderer = function(params) {return <span>{(params.value) ? <FontAwesomeIcon icon={faImages}/> : <span/>}</span>};
                }
                else if (col.cellRenderType === "TrueFalseDocRenderer")
                {
                    newColumn.cellRenderer = function(params) {return <span>{(params.value) ? <FontAwesomeIcon icon={faFileAlt}/> : <span/>}</span>};
                }
                else if (col.cellRenderType === "ArrayListPropRenderer")
                {
                    // should include propName, the name of the property in the array that we want to generate
                    newColumn.cellRendererParams = col.cellRendererParams;
                    newColumn.cellRenderer = function(params) {return (Array.isArray(params.value)) ?
                         <span>{params.value.map((v) => {return v[params.propName]}).join(" ")}</span> 
                        : <span/>};
                }
            }


            if (col.cellStyles){
                newColumn.cellStyle =  function(params) {
                    var colors = valToColor(params.value, col.cellStyles);
                    return {
                      color: colors.color,
                      backgroundColor: colors.backgroundColor
                    }
                }             
              }


            //console.log("renderColumn: ");
            //console.log(newColumn);
            return newColumn;
        })
        var result = columns;
      
        return result;
    }


}